/**
 * AdvisorLauncher.tsx — floating action button that opens the AI Strategy Advisor (T-501).
 *
 * Design decision: a floating button pinned over the map (bottom-right), reachable from any
 * zoom/selection state. Hidden while the panel is open (the panel has its own close control).
 */
import { MessageSquareText } from 'lucide-react'

export interface AdvisorLauncherProps {
  onOpen: () => void
  hidden?: boolean
}

export function AdvisorLauncher({ onOpen, hidden = false }: AdvisorLauncherProps) {
  if (hidden) return null
  return (
    <button
      onClick={onOpen}
      aria-label="Open Strategy Advisor"
      className="fixed bottom-12 right-4 z-10 flex items-center gap-2 rounded-full
                 bg-primary px-4 py-3 text-sm font-medium text-primary-foreground shadow-lg
                 hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2
                 focus-visible:ring-ring"
    >
      <MessageSquareText className="h-4 w-4" />
      <span className="hidden sm:inline">Ask the Advisor</span>
    </button>
  )
}
